var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isOverlayShown
    ? _c(
        "div",
        { attrs: { "data-overlay": "" }, on: { click: _vm.onOverlayClicked } },
        [_vm._t("popup", null, { isOverlayShown: _vm.isOverlayShown })],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }